import { createColumnHelper } from '@tanstack/react-table'

export const columnHelper = createColumnHelper<APIIntegration>()
